import type { IStockRepository, AssetListOptions } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockAssetEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createListAssetsUseCase({ stockRepository }: Deps) {
  return async function listAssets(options: AssetListOptions): Promise<StockAssetEntity[]> {
    return stockRepository.listAssets(options);
  };
}
